import { CajaCurricularPciI } from "interfaces/CajaCurricularPci";
import { PciI, InstitucionI } from "interfaces/Pci";
import { infoFetchGetPlanesEstudioI, makePlanEstudio } from "./planEstudio";
import { PlanEstudioI } from "interfaces/PlanEstudio";
import { NormativaI } from "interfaces/Normativa";
import { EstadoDiseñoCurricularI } from "interfaces/EstadoDiseñoCurricular";
import {
  infoFetchGetCajaCurricularPciI,
  makeCajaCurricularPci,
} from "./cajaCurricularPci";

export interface infoFetchGetPciI {
  id: number | string;
  nombre: string;
  anio_implementacion: number;
  planEstudio: infoFetchGetPlanesEstudioI;
  institucion: InstitucionI;
  normativas?: NormativaI[];
  estado: EstadoDiseñoCurricularI;
  cajaCurricularPci: infoFetchGetCajaCurricularPciI | null;
}

export interface ImportacionMasivaResponseI {
  nombreArchivo: string;
  nombreImportacion: string;
  fechaImportacion: string;
  resumen: ResumenImportacion;
  errores: ResponseRow[];
}

interface ResumenImportacion {
  totalFilas: number;
  filasExitosas: number;
  filasConError: number;
  duracion: string;
}

export interface ResponseRow {
  fila: string;
  estado: "success" | "error";
  error: string | null;
}

class Pci implements PciI {
  id: number | string;
  nombre: string;
  anio_implementacion: number;
  planEstudio: PlanEstudioI;
  institucion: InstitucionI;
  normativas?: NormativaI[];
  estado: EstadoDiseñoCurricularI;
  cajaCurricularPci: CajaCurricularPciI | null;

  constructor(dto: infoFetchGetPciI) {
    this.id = dto.id;
    this.nombre = dto.nombre;
    this.anio_implementacion = dto.anio_implementacion;
    // TODO: Descomentar 
    // this.planEstudio = makePlanEstudio(dto.planEstudio);
    this.planEstudio = dto.planEstudio as any;
    this.institucion = dto.institucion;
    this.normativas = dto.normativas;
    this.estado = dto.estado;
    this.cajaCurricularPci = dto.cajaCurricularPci
      ? makeCajaCurricularPci(dto.cajaCurricularPci)
      : null;
  }
}

export const makePci = (infoFetch: infoFetchGetPciI) => {
  return new Pci(infoFetch);
};
